import type { ITenant } from 'types/globals';

/** Only explicit `false` means onboarding is incomplete; missing field ⇒ complete (legacy APIs). */
export function isTenantOnboardingComplete(tenant: ITenant): boolean {
  return tenant.is_onboarding_completed !== false;
}
